import { error, robotoRegular, turquoise800, turquoise900, white } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperModaPaymentOneClick = styled.div`
    h1{
        font-size: 26px;
        text-align: center;
    }
    text-align: left;
    overflow-wrap: break-word;
    .WrapperUrl{
        display: grid;
        grid-template-columns: auto 60px;
        grid-gap: 5px;
        margin-bottom: 15px;
    }
    .btnCopy{
        width: 60px;
        height: 50px;
        position: relative;
        top: 7px;
        border-radius: 10px;
        background: ${turquoise800};
        border: none;
        color: ${white};
        cursor: pointer;
        &:active {
            background-color: ${turquoise900};
        }
    }
`;

export const WrapperError = styled.div`
    color: ${error};
    font-size: 9pt;
    width: 131px;
    margin-top: 5px;
`;

/** Aviso bajo el CTA (ej. restricción de método de pago por monto). */
export const PaymentCtaFooterNotice = styled.p`
    margin: 10px 0 0;
    max-width: 100%;
    font-family: ${robotoRegular};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;
    color: #b45309;
`;